const ES = {
  custom: {
    name: {
      required: "*Ingrese el nombre."
    },
    lastname: {
      required: "*Ingrese el apellido."
    },
    cityID: {
      required: "*Seleccione la ciudad."
    },
    address: {
      required: "*Agregue la dirección"
    }
  }
};

const EN = {
  custom: {
    name: {
      required: "*Enter name."
    },
    lastname: {
      required: "*Enter last name."
    },
    cityID: {
      required: "*Select the city."
    },
    address: {
      required: "*Add address"
    }
  }
};

const PT = {
  custom: {
    name: {
      required: "*Insira o nome."
    },
    lastname: {
      required: "*Insira o último nome."
    },
    cityID: {
      required: "*Selecione a cidade."
    },
    address: {
      required: "*Adicionar endereço"
    }
  }
};

export { ES, EN, PT };

